import { jsPDF } from "jspdf";
import { formatCurrency } from "../../../../utils/textUtils";

export const generatePartialSalaryPDF = (batch, employeeList) => {
  console.log({employeeList})
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  const margin = 10;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let currentY = 20;

  const addNewPage = () => {
    doc.addPage();
    currentY = 20;
    drawHeader();
  };

  const drawHeader = () => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("RBL Fishing Corporation", pageWidth / 2, currentY, { align: "center" });
    currentY += 6;
    doc.setFontSize(10);
    doc.text("List of Partial Salary Released", pageWidth / 2, currentY, { align: "center" });
    currentY += 10;

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`As of Date: ${batch.effectiveDate?.split('T')[0] || "---"}`, margin, currentY);
    doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth - margin, currentY, { align: "right" });
    currentY += 5;

    // Table Headers
    doc.setLineWidth(0.2);
    doc.line(margin, currentY, pageWidth - margin, currentY);
    currentY += 5;
    doc.setFont("helvetica", "bold");
    doc.text("Employee No", margin, currentY);
    doc.text("Full Name", margin + 25, currentY);
    doc.text("Expected Cutoff", margin + 85, currentY);
    doc.text("Released", margin + 115, currentY);
    doc.text("Payment", margin + 135, currentY);
    doc.text("Balance", margin + 155, currentY);
    doc.text("Signature", margin + 175, currentY);
    currentY += 3;
    doc.line(margin, currentY, pageWidth - margin, currentY);
    currentY += 7;
  };

  drawHeader();

  // Destination Header (Vessel)
  doc.setFont("helvetica", "bold");
  doc.text(`Destination:   ${batch.vesselCode || ""}   ${batch.vesselName || ""}`, margin, currentY);
  currentY += 7;

  // Employee Rows
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  
  let totalAmount = 0;
  const eligibleEmployees = employeeList.filter(e => e.isEligible === true || e.isEligibleRaw === true);

  eligibleEmployees.forEach((emp) => {
    if (currentY > pageHeight - 60) { // Check for page break
        addNewPage();
    }

    const amt = emp.amountRaw || parseFloat(String(emp.amount).replace(/,/g, '')) || 0;
    totalAmount += amt;

    doc.text(String(emp.employeeId || "---"), margin, currentY);
    doc.text(String(emp.employeeFullName || "---"), margin + 25, currentY);
    doc.text(batch.effectiveDate?.split('T')[0] || "---", margin + 85, currentY);
    doc.text(formatCurrency(amt), margin + 125, currentY, { align: "right" });
    doc.text(formatCurrency(amt), margin + 145, currentY, { align: "right" });
    doc.text("0.00", margin + 165, currentY, { align: "right" });
    
    // Signature Line
    doc.line(margin + 175, currentY + 1, margin + 195, currentY + 1);

    currentY += 6;
  });

  // Totals Section
  currentY += 4;
  doc.line(margin, currentY, pageWidth - margin, currentY);
  currentY += 6;
  doc.setFont("helvetica", "bold");
  doc.text(`Totals:       ${eligibleEmployees.length} employees`, margin, currentY);
  doc.text(formatCurrency(totalAmount), margin + 125, currentY, { align: "right" });
  doc.text(formatCurrency(totalAmount), margin + 145, currentY, { align: "right" });
  doc.text("0.00", margin + 165, currentY, { align: "right" });

  // Signature Section
  currentY += 20;
  if (currentY > pageHeight - 40) addNewPage();

  const col1 = margin;
  const col2 = margin + 100;

  doc.setFontSize(9);
  // Row 1
  doc.text("Prepared By:", col1, currentY);
  doc.line(col1 + 25, currentY + 1, col1 + 80, currentY + 1);

  doc.text("Checked By:", col2, currentY);
  doc.line(col2 + 25, currentY + 1, col2 + 80, currentY + 1);

  currentY += 15;
  // Row 2
  doc.text("Approved By:", col1, currentY);
  doc.line(col1 + 25, currentY + 1, col1 + 80, currentY + 1);

  doc.text("Received By:", col2, currentY);
  doc.line(col2 + 25, currentY + 1, col2 + 80, currentY + 1);

  doc.save(`Partial_Salary_Batch_${batch.id}.pdf`);
};